module.exports = __webpack_public_path__ + "060caf85f0e9c75d416d352c8c05472c.svg";